import { useFont } from '@octane/spark'
import styled, { css } from 'styled-components'

export const NavbarItemStyled = styled.li<{
    isWider?: boolean
    isActive?: boolean
    isNavbarWhite?: boolean
}>`
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 5px;
    margin-right: 5px;
    height: 60px;
    max-height: 60px;
    position: relative;

    ${(props) =>
        props.isWider
            ? `
        width: 95px;
    `
            : `
        width: 75px;
    `}

    span {
        ${() => useFont('c12', { weight: '400' })};
        margin-top: 4px;
        text-align: center;
    }

    ${({ theme, isActive, isNavbarWhite }) => css`
        span,
        svg,
        path {
            color: ${theme.colors.monochrome.white};
            fill: ${theme.colors.monochrome.white};
        }

        &:hover {
            background-color: ${theme.states.interaction.primary.hover.value};
        }

        ${isActive &&
        css`
            background-color: ${theme.colors.interaction.alternative};
            span,
            svg,
            path {
                color: ${theme.states.interaction.primary.active.value};
                fill: ${theme.states.interaction.primary.active.value};
            }
            span {
                font-weight: 700;
            }
            &:hover {
                background-color: ${theme.colors.interaction.alternative};
            }
        `}

        ${isNavbarWhite &&
        css`
            background-color: ${theme.colors.monochrome.white};

            span,
            svg,
            path {
                color: ${theme.colors.brand.primary};
                fill: ${theme.colors.brand.primary};
            }

            &:hover {
                background-color: ${theme.colors.interaction.alternative};
            }

            ${isActive &&
            css`
                background-color: ${theme.colors.interaction.alternative};

                span,
                svg,
                path {
                    color: ${theme.states.interaction.primary.active.value};
                    fill: ${theme.states.interaction.primary.active.value};
                }

                span {
                    font-weight: 700;
                }

                &:hover {
                    background-color: ${theme.colors.interaction.alternative};
                }
            `}
        `}
    `}
`

export const NavbarItemLink = styled.a<{
    isActive?: boolean
}>`
    text-shadow: 0 1px 0 rgba(255, 255, 255, 0.25);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    & > div {
        position: relative;
    }
`

export const NotificationCounter = styled.span`
    position: absolute;
    top: -4px;
    left: 20px;
    background-color: ${(props) => props.theme.colors.alert.warning};
    color: white !important;
    border-radius: 10px;
    padding: 0 5px;
    font-size: 10px !important;
    font-weight: bold !important;
    max-width: 25px;
    height: 15px;
    display: flex;
    align-items: center;
    justify-content: center;
`

export const NavbarNavLabel = styled.span``
